 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"APIManagement":"APIManagement","Accelerator":"Accelerator","ActPage":"ActPage","Address":"Address","AntiFake":"AntiFake","BrandKit":"BrandKit","ButtonOnce":"ButtonOnce","Careers":"Careers","CertificationPersonal~NftInformation":"CertificationPersonal~NftInformation","CertificationPersonal":"CertificationPersonal","Deposit~WithDraw":"Deposit~WithDraw","Deposit":"Deposit","WithDraw":"WithDraw","DownLoad":"DownLoad","ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba":"ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba","NftInformation":"NftInformation","ForgotPassword~SignIn~SignUp":"ForgotPassword~SignIn~SignUp","ForgotPassword":"ForgotPassword","SignUp":"SignUp","Nft":"Nft","NftAsset~NftCollection~NftHistory":"NftAsset~NftCollection~NftHistory","NftAsset":"NftAsset","NftCollection":"NftCollection","NftHistory":"NftHistory","NftDetail":"NftDetail","NftList":"NftList","Security":"Security","SignIn":"SignIn","Home~earn":"Home~earn","Home":"Home","IeoDetail":"IeoDetail","IeoHome":"IeoHome","Lang-ar":"Lang-ar","Lang-de":"Lang-de","Lang-en":"Lang-en","Lang-es":"Lang-es","Lang-fa":"Lang-fa","Lang-hi":"Lang-hi","Lang-it":"Lang-it","Lang-ja":"Lang-ja","Lang-ko":"Lang-ko","Lang-ma":"Lang-ma","Lang-pt":"Lang-pt","Lang-ru":"Lang-ru","Lang-tr":"Lang-tr","Lang-vi-VN":"Lang-vi-VN","Lang-zh-hans":"Lang-zh-hans","Lang-zh-hant":"Lang-zh-hant","Launchpad":"Launchpad","Listings~Markets":"Listings~Markets","Listings":"Listings","Markets":"Markets","Loading":"Loading","NftWithdraw":"NftWithdraw","Novice":"Novice","Overlay":"Overlay","OverlayConfirm":"OverlayConfirm","Payments":"Payments","UserCenter":"UserCenter","ambassadorPage":"ambassadorPage","blog-detail":"blog-detail","blog-home":"blog-home","Dao":"Dao","DaoList":"DaoList","earn":"earn","Invitation":"Invitation","Kickstarter":"Kickstarter","KickstarterDeatil":"KickstarterDeatil","DaoDetail":"DaoDetail","identity":"identity","launchpadDetail~launchpadPlut":"launchpadDetail~launchpadPlut","launchpadDetail":"launchpadDetail","launchpadPlut":"launchpadPlut","live":"live","union-referral":"union-referral","user-center-frame":"user-center-frame","user-center-profile":"user-center-profile"}[chunkId]||chunkId) + "." + {"APIManagement":"207d084f","Accelerator":"1d305e0b","ActPage":"74b2cc6f","Address":"5ac70578","AntiFake":"3f0bc4f7","BrandKit":"ffeae76b","ButtonOnce":"707bd544","Careers":"8e18c225","CertificationPersonal~NftInformation":"8e306cce","CertificationPersonal":"95073ad4","Deposit~WithDraw":"ea45a6bf","Deposit":"d65fdca1","WithDraw":"b9c8d2aa","DownLoad":"3edcca04","ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba":"d11ea28d","NftInformation":"a2588e17","ForgotPassword~SignIn~SignUp":"3a8f4445","ForgotPassword":"3b23a816","SignUp":"0f9f53c5","Nft":"746db896","NftAsset~NftCollection~NftHistory":"c59382c1","NftAsset":"075c1d37","NftCollection":"f87eee14","NftHistory":"4aace04c","NftDetail":"b93e1347","NftList":"cdc11521","Security":"177c14df","SignIn":"6bda0762","Home~earn":"6015a0fc","Home":"ef7c01cb","IeoDetail":"5d593aa2","IeoHome":"57872c1e","Lang-ar":"f99abc5b","Lang-de":"72b0d17d","Lang-en":"3de7e922","Lang-es":"337e0613","Lang-fa":"e05e4d11","Lang-hi":"f4c61ac9","Lang-it":"4ccf4910","Lang-ja":"850a9dfd","Lang-ko":"1d8e60fc","Lang-ma":"9fb462fd","Lang-pt":"0a503814","Lang-ru":"7b577ab0","Lang-tr":"541ef18c","Lang-vi-VN":"97193b04","Lang-zh-hans":"481f7f4f","Lang-zh-hant":"57cb2660","Launchpad":"5026af21","Listings~Markets":"39d7b205","Listings":"a1e037c4","Markets":"d03a2cc8","Loading":"83264cfe","NftWithdraw":"30e8e5ff","Novice":"a325afc9","Overlay":"af9e3d3d","OverlayConfirm":"6195a1a9","Payments":"9f92a253","UserCenter":"6fcc039d","ambassadorPage":"4f72d601","blog-detail":"8f5d2cf7","blog-home":"8abdf1b6","chunk-203f7664":"201eed8d","chunk-32d3d647":"f9544f84","chunk-461508e9":"7e81ac83","chunk-3e34ed86":"477342d1","chunk-5c74b150":"5acf075e","chunk-7c11d3c3":"eccdd084","chunk-8e8be46e":"5afd1aaf","chunk-56059747":"b1d96993","chunk-07dd191b":"19b3c2c8","chunk-c50e6c4e":"e7590094","chunk-78599fa4":"36fc573a","Dao":"5572d584","DaoList":"db05561c","earn":"dc08d910","chunk-16061caa":"c8ee04cd","Invitation":"6e0a0e97","chunk-21d616ac":"3d1800fe","chunk-72949d14":"9e2c425d","chunk-93de0436":"3b54172a","Kickstarter":"eacd83a3","KickstarterDeatil":"897a0e8b","DaoDetail":"0785d612","chunk-1567687f":"b2024e77","chunk-654013a4":"b840aeb6","chunk-c865cf0c":"f972837b","chunk-c4d95cdc":"dc159bc5","chunk-4c2183d6":"af6e1341","chunk-05e5624f":"5695eda3","chunk-462fac04":"5e5cbc20","chunk-ff8b746c":"8f86fd8b","chunk-acfb8b64":"d7f406ea","chunk-ebc879d8":"9de86c43","identity":"a0e1e09c","launchpadDetail~launchpadPlut":"13c41dbe","launchpadDetail":"d10e3e41","launchpadPlut":"891a166b","live":"20687074","union-referral":"0467b931","user-center-frame":"d066d170","user-center-profile":"7b281c96"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"APIManagement":1,"Accelerator":1,"ActPage":1,"Address":1,"AntiFake":1,"BrandKit":1,"ButtonOnce":1,"Careers":1,"CertificationPersonal":1,"Deposit~WithDraw":1,"Deposit":1,"WithDraw":1,"DownLoad":1,"NftInformation":1,"ForgotPassword~SignIn~SignUp":1,"SignUp":1,"Nft":1,"NftAsset~NftCollection~NftHistory":1,"NftDetail":1,"Security":1,"SignIn":1,"Home~earn":1,"Home":1,"IeoDetail":1,"IeoHome":1,"Launchpad":1,"Markets":1,"Loading":1,"Novice":1,"Payments":1,"blog-detail":1,"blog-home":1,"chunk-203f7664":1,"chunk-3e34ed86":1,"chunk-07dd191b":1,"chunk-c50e6c4e":1,"Dao":1,"DaoList":1,"earn":1,"chunk-16061caa":1,"Invitation":1,"chunk-21d616ac":1,"chunk-72949d14":1,"Kickstarter":1,"KickstarterDeatil":1,"DaoDetail":1,"chunk-1567687f":1,"chunk-654013a4":1,"chunk-c865cf0c":1,"chunk-c4d95cdc":1,"chunk-4c2183d6":1,"chunk-05e5624f":1,"chunk-462fac04":1,"chunk-ff8b746c":1,"chunk-acfb8b64":1,"identity":1,"live":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"APIManagement":"APIManagement","Accelerator":"Accelerator","ActPage":"ActPage","Address":"Address","AntiFake":"AntiFake","BrandKit":"BrandKit","ButtonOnce":"ButtonOnce","Careers":"Careers","CertificationPersonal~NftInformation":"CertificationPersonal~NftInformation","CertificationPersonal":"CertificationPersonal","Deposit~WithDraw":"Deposit~WithDraw","Deposit":"Deposit","WithDraw":"WithDraw","DownLoad":"DownLoad","ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba":"ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba","NftInformation":"NftInformation","ForgotPassword~SignIn~SignUp":"ForgotPassword~SignIn~SignUp","ForgotPassword":"ForgotPassword","SignUp":"SignUp","Nft":"Nft","NftAsset~NftCollection~NftHistory":"NftAsset~NftCollection~NftHistory","NftAsset":"NftAsset","NftCollection":"NftCollection","NftHistory":"NftHistory","NftDetail":"NftDetail","NftList":"NftList","Security":"Security","SignIn":"SignIn","Home~earn":"Home~earn","Home":"Home","IeoDetail":"IeoDetail","IeoHome":"IeoHome","Lang-ar":"Lang-ar","Lang-de":"Lang-de","Lang-en":"Lang-en","Lang-es":"Lang-es","Lang-fa":"Lang-fa","Lang-hi":"Lang-hi","Lang-it":"Lang-it","Lang-ja":"Lang-ja","Lang-ko":"Lang-ko","Lang-ma":"Lang-ma","Lang-pt":"Lang-pt","Lang-ru":"Lang-ru","Lang-tr":"Lang-tr","Lang-vi-VN":"Lang-vi-VN","Lang-zh-hans":"Lang-zh-hans","Lang-zh-hant":"Lang-zh-hant","Launchpad":"Launchpad","Listings~Markets":"Listings~Markets","Listings":"Listings","Markets":"Markets","Loading":"Loading","NftWithdraw":"NftWithdraw","Novice":"Novice","Overlay":"Overlay","OverlayConfirm":"OverlayConfirm","Payments":"Payments","UserCenter":"UserCenter","ambassadorPage":"ambassadorPage","blog-detail":"blog-detail","blog-home":"blog-home","Dao":"Dao","DaoList":"DaoList","earn":"earn","Invitation":"Invitation","Kickstarter":"Kickstarter","KickstarterDeatil":"KickstarterDeatil","DaoDetail":"DaoDetail","identity":"identity","launchpadDetail~launchpadPlut":"launchpadDetail~launchpadPlut","launchpadDetail":"launchpadDetail","launchpadPlut":"launchpadPlut","live":"live","union-referral":"union-referral","user-center-frame":"user-center-frame","user-center-profile":"user-center-profile"}[chunkId]||chunkId) + "." + {"APIManagement":"147ae378","Accelerator":"f2941883","ActPage":"59052e8b","Address":"c0b12e54","AntiFake":"36abd619","BrandKit":"0c50ac9c","ButtonOnce":"515de884","Careers":"c7995482","CertificationPersonal~NftInformation":"31d6cfe0","CertificationPersonal":"797a94c8","Deposit~WithDraw":"1bedabb8","Deposit":"c996f9f6","WithDraw":"c044ce56","DownLoad":"20196083","ForgotPassword~Invitation~Nft~NftAsset~NftCollection~NftDetail~NftHistory~NftInformation~NftList~Sec~e2dfdbba":"31d6cfe0","NftInformation":"ae241f74","ForgotPassword~SignIn~SignUp":"861be38c","ForgotPassword":"31d6cfe0","SignUp":"81b83b4d","Nft":"a1a9c9ef","NftAsset~NftCollection~NftHistory":"3f7f2c6c","NftAsset":"31d6cfe0","NftCollection":"31d6cfe0","NftHistory":"31d6cfe0","NftDetail":"a86ed9a8","NftList":"31d6cfe0","Security":"0fc8d08f","SignIn":"81b83b4d","Home~earn":"4d609d28","Home":"e05d37a6","IeoDetail":"a533e498","IeoHome":"fb542b8a","Lang-ar":"31d6cfe0","Lang-de":"31d6cfe0","Lang-en":"31d6cfe0","Lang-es":"31d6cfe0","Lang-fa":"31d6cfe0","Lang-hi":"31d6cfe0","Lang-it":"31d6cfe0","Lang-ja":"31d6cfe0","Lang-ko":"31d6cfe0","Lang-ma":"31d6cfe0","Lang-pt":"31d6cfe0","Lang-ru":"31d6cfe0","Lang-tr":"31d6cfe0","Lang-vi-VN":"31d6cfe0","Lang-zh-hans":"31d6cfe0","Lang-zh-hant":"31d6cfe0","Launchpad":"c1ca6b7f","Listings~Markets":"31d6cfe0","Listings":"31d6cfe0","Markets":"a86ed9a8","Loading":"c0f684de","NftWithdraw":"31d6cfe0","Novice":"a6f59385","Overlay":"31d6cfe0","OverlayConfirm":"31d6cfe0","Payments":"d072274a","UserCenter":"31d6cfe0","ambassadorPage":"31d6cfe0","blog-detail":"5edf1bbe","blog-home":"105ec64e","chunk-203f7664":"3fb3644a","chunk-32d3d647":"31d6cfe0","chunk-461508e9":"31d6cfe0","chunk-3e34ed86":"3e18a206","chunk-5c74b150":"31d6cfe0","chunk-7c11d3c3":"31d6cfe0","chunk-8e8be46e":"31d6cfe0","chunk-56059747":"31d6cfe0","chunk-07dd191b":"85c1e7b6","chunk-c50e6c4e":"b75b8fb2","chunk-78599fa4":"31d6cfe0","Dao":"421ac8a8","DaoList":"db86e518","earn":"a906355f","chunk-16061caa":"eae80702","Invitation":"a86ed9a8","chunk-21d616ac":"d6a73ea5","chunk-72949d14":"38cfb27e","chunk-93de0436":"31d6cfe0","Kickstarter":"e0771674","KickstarterDeatil":"a4548662","DaoDetail":"73078e82","chunk-1567687f":"465ec844","chunk-654013a4":"0445b96c","chunk-c865cf0c":"384e8e92","chunk-c4d95cdc":"b2d30fcc","chunk-4c2183d6":"07feb2fc","chunk-05e5624f":"3f4a7775","chunk-462fac04":"8d602cb3","chunk-ff8b746c":"17c21150","chunk-acfb8b64":"9843e521","chunk-ebc879d8":"31d6cfe0","identity":"96a3ab56","launchpadDetail~launchpadPlut":"31d6cfe0","launchpadDetail":"31d6cfe0","launchpadPlut":"31d6cfe0","live":"8f0574d2","union-referral":"31d6cfe0","user-center-frame":"31d6cfe0","user-center-profile":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
